<template>
    
    <ContentWrapper>
        
        <SectionHeader subheader="Subheader" title="Section Title about the Section and How it Works" />

        <div class="flex flex-col md:flex-row gap-4 mt-18">
            <div class="rounded rounded-tl-4xl bg-gray-100 p-4 md:w-2/3 h-96">
               
            </div>

            <div class="rounded rounded-br-4xl bg-gray-100 p-4 md:w-1/3 h-96">

            </div>
        </div>

        <div class="flex flex-col md:flex-row gap-4 mt-4">
            <div class="rounded rounded-tl-4xl bg-gray-100 p-4 md:w-1/3 h-96">
               
            </div>

            <div class="rounded rounded-br-4xl bg-gray-100 p-4 md:w-2/3 h-96">

            </div>
        </div>

    </ContentWrapper>
</template>

<script setup>

import ContentWrapper from '../Layouts/ContentWrapper.vue'
import SectionHeader from '../Layouts/SectionHeader.vue'

</script>
